import { render, staticRenderFns } from "./SelectorMenuHeading.vue?vue&type=template&id=30589f17&scoped=true"
import script from "./SelectorMenuHeading.vue?vue&type=script&lang=js"
export * from "./SelectorMenuHeading.vue?vue&type=script&lang=js"
import style0 from "./SelectorMenuHeading.vue?vue&type=style&index=0&id=30589f17&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30589f17",
  null
  
)

export default component.exports